export const LOT_TABLE = "lots"
export const LOT_TABLE_SCHEMA =
  "id, companyId, lotNumber, supplierId, status, syncId"
